export const ReportErrorBoundary = () => {
    return (
        <div>
            <h1>An error occured while loading the report</h1>
        </div>
    );
};
